import { render, staticRenderFns } from "./TeamsportToplist.vue?vue&type=template&id=9e509c8a&scoped=true"
import script from "./TeamsportToplist.vue?vue&type=script&lang=js"
export * from "./TeamsportToplist.vue?vue&type=script&lang=js"
import style0 from "./TeamsportToplist.vue?vue&type=style&index=0&id=9e509c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e509c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VAvatar,VDataTable,VProgressCircular})
